export const StandardLabelCapitalization = (internalLabel: string) => {
  return internalLabel[0] + internalLabel.substring(1).toLowerCase().replace(/_/g, " ");
};

export function ucfirst(ipt: string) {
  if (ipt.length > 0) {
    return ipt[0].toUpperCase() + ipt.slice(1);
  }
  return ipt;
}

const smallWords = ["a", "an", "and", "as", "at", "but", "by", "en", "for", "if", "in", "of", "on", "or", "the", "to"];
export function titleCaseWord(ipt: string) {
  if (ipt.toLowerCase() === "bluecross") {
    return "BlueCross";
  }
  if (ipt.toLowerCase() === "blueshield") {
    return "BlueShield";
  }
  if (ipt.toLowerCase() === "healthpartners") {
    return "HealthPartners";
  }
  if (ipt.toLowerCase() === "amerihealth") {
    return "AmeriHealth";
  }

  if (smallWords.includes(ipt.toLowerCase())) {
    return ipt.toLowerCase();
  }

  // Words without vowels are definitely abbreviations and should be upper case
  if (
    // At least two chars long
    ipt.length > 1 &&
    // Consists only of letters
    /^[a-z]+$/i.test(ipt) &&
    // Doesn't have a vowel
    !/[aeiouy]/i.test(ipt)
  ) {
    return ipt.toUpperCase();
  }

  return ucfirst(ipt.toLowerCase());
}
